import React from 'react';
import { Button } from '@components/Button';
import { Info } from '@components/Info';
import { ButtonVariants } from '@components/Button/types';
import { InfoVariants } from '@components/Info/types';

import './styles.scss';

interface IWarningMessageProps {
  title: string;
  message: string;
  buttonLabel: string;
  buttonVariants: ButtonVariants;
  variant: InfoVariants;
  onButtonClick: () => void;
}

export const WarningMessage: React.FC<IWarningMessageProps> = ({
  title,
  message,
  buttonLabel,
  buttonVariants,
  onButtonClick,
  variant,
}) => (
  <div className={`warning-message ${variant}`}>
    <p className="warning-title">{title}</p>
    <Info text={message} variant={variant} />
    <br />
    <Button label={buttonLabel} size="large" variant={buttonVariants} handleClick={onButtonClick} />
  </div>
);
